import { Home } from "./views/Home";
import "./styles/App.scss";

function App() {
  return (
    <div className="App">
      <Home />
    </div>
  );
}

export default App;
